// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujKpi.js
//  SujKpi
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export function SujKpi({ icon, label, value, color, active, onClick }) {
  return (
    <div onClick={onClick}
      style={{
        flex: "1 1 140px", minWidth: 125, background: THEME.panel,
        border: `1px solid ${active ? (color || THEME.accent) : THEME.border}`,
        borderRadius: 12, padding: "12px 14px", cursor: onClick ? "pointer" : "default",
      }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, color: color || THEME.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", marginBottom: 6, minHeight: 26 }}>
        {icon && <span style={{ fontSize: 13 }}>{icon}</span>}<span>{label}</span>
      </div>
      <div style={{ color: THEME.text, fontSize: 25, fontWeight: 800, lineHeight: 1 }}>{value}</div>
    </div>
  );
}
